/**
 * Linear Assets — Analysis Review & Engineer Sign-Off Gate (Step 7)
 */

import React, { useState } from 'react';
import { ClipboardCheck, ShieldCheck, CheckCircle2, Lock, ArrowRight, Download } from 'lucide-react';
import Card from '../../components/common/Card';
import Button from '../../components/common/Button';
import Alert from '../../components/common/Alert';
import { useNavigate } from 'react-router-dom';
import { reportsApi } from '../../services/api';

export const LinearAnalysisReviewPage: React.FC = () => {
  const navigate = useNavigate();
  const [signedOff, setSignedOff] = useState(false);

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
            <ClipboardCheck className="w-7 h-7 text-amber-500" /> Linear Analysis Review (Gate 2)
          </h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Power line &amp; railway asset manager verification — confirm conductor breach and release clearance work orders
          </p>
        </div>
      </div>

      <Card className="space-y-4">
        <div className="flex items-center justify-between pb-3 border-b border-gray-100 dark:border-gray-800">
          <div>
            <h3 className="font-bold text-base text-gray-900 dark:text-white">Power Line Sector 7 &bull; Km 12.4 &ndash; Km 14.1</h3>
            <p className="text-xs text-gray-500">Conductor clearance violation confirmed via LiDAR inspection</p>
          </div>
          <span className={`px-2.5 py-0.5 rounded font-bold text-xs uppercase ${signedOff ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-800'}`}>
            {signedOff ? 'Digitally Sealed' : 'Awaiting Sign-Off'}
          </span>
        </div>

        <div className="p-3 bg-gray-50 dark:bg-gray-800 rounded-lg text-xs space-y-1">
          <p><strong>Diagnosis:</strong> 4 Eucalyptus trees encroaching within 3.82m of 275kV conductor (Safety Buffer: 5.0m).</p>
          <p><strong>Recommended Action:</strong> Tree trimming / clearing crew dispatch with bucket truck &amp; live-line certified arborists.</p>
        </div>

        <div className="pt-3 border-t border-gray-100 dark:border-gray-800 flex items-center justify-between">
          {!signedOff ? (
            <Button variant="primary" onClick={() => setSignedOff(true)} className="flex items-center gap-1.5">
              <ShieldCheck className="w-4 h-4" /> Authorise Vegetation Clearance &amp; Seal Record
            </Button>
          ) : (
            <div className="flex items-center gap-3 w-full justify-between">
              <span className="text-xs text-green-600 font-semibold flex items-center gap-1">
                <Lock className="w-4 h-4" /> Cryptographic SHA-256 seal created and stamped
              </span>
              <Button variant="primary" onClick={() => navigate('/linear-assets/response')} className="flex items-center gap-1.5">
                Proceed to Step 8 Response Planning <ArrowRight className="w-4 h-4" />
              </Button>
            </div>
          )}
        </div>
      </Card>
    </div>
  );
};

export default LinearAnalysisReviewPage;
